/**
 * Created by nijin on 23/12/16.
 */
import {Component, OnInit, OnDestroy} from '@angular/core';
import {ThingsService} from "../things.service";
import {Router} from "@angular/router";
@Component({
    selector: 'nuc-done',
    templateUrl: './done.component.html',
    styleUrls:['./done.component.scss']
})
export class ThingOnBoardedComponent implements OnInit {
    constructor(private thingService: ThingsService,
    private router: Router) { }

    ngOnInit() {
     this.thingService.getThingCreateSubject()
        .subscribe((response)=>{
       if(!response.isApp){
         setTimeout(()=> { this.router.navigate(['/things']); }, 2500);
       }
        });
    }




}



// WEBPACK FOOTER //
// ./src/app/things/onboard/done.component.ts